
// ─── UTILITY:───────────────
function waitForShadow(cb) {
  const sc = document.querySelector("shadow-dom-container");
  if (sc && sc.shadowRoot) { cb(sc.shadowRoot); return; }

  const obs = new MutationObserver(function () {
    const sc2 = document.querySelector("shadow-dom-container");
    if (sc2 && sc2.shadowRoot) {
      obs.disconnect();
      cb(sc2.shadowRoot);
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
}

// ─── UTILITY: debounce helper ─────────────────────────────────
function debounce(fn, delay) {
  let timer;
  return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
}


// ─── 1. REVIEW BUTTON LOAD MORE ICON ─────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  function injectIcons() {
    document.querySelectorAll('.jdgm-paginate__load-more').forEach(function (btn) {
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = 'View More';
      });
      if (btn.querySelector('.custom-arrow-icon')) return;

      const icon = document.createElement('span');
      icon.className = 'custom-arrow-icon';
      icon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <rect x="0.5" y="-0.5" width="19" height="19" rx="9.5"
            transform="matrix(1 0 0 -1 0.5 19.2014)" stroke="#808080"/>
          <path d="M7 8.7431L10.5 11.6598L14 8.7431" stroke="#808080" stroke-linecap="round"/>
        </svg>`;
      btn.appendChild(icon);
    });
  }

  function updateIconRotation(btn) {
    const icon = btn.querySelector('.custom-arrow-icon');
    if (!icon) return;
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    icon.classList.toggle('rotate-down', isExpanded);
    icon.classList.toggle('rotate-up', !isExpanded);
  }

  injectIcons();
  document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);

  new MutationObserver(debounce(function () {
    injectIcons();
    document.querySelectorAll('.jdgm-paginate__load-more').forEach(updateIconRotation);
  }, 100)).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.jdgm-paginate__load-more');
    if (btn) updateIconRotation(btn);
  });
});


// ─── 2. JUDGEME REVIEW COMMENT COUNT ─────────────────────────
(function () {
  function formatWithCommas(str) {
    const num = parseInt(str.replace(/,/g, ''), 10);
    if (isNaN(num)) return str;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function fixReviewNumbers() {
    const badge = document.querySelector('.jdgm-prev-badge__text');
    if (badge && badge.textContent) {
      const fixed = badge.textContent.replace(/\((\d+)\s*reviews?\)/gi, function (_, num) {
        return '(' + formatWithCommas(num) + ' reviews)';
      });
      if (fixed !== badge.textContent) badge.textContent = fixed;
    }

    const count = document.getElementById('jdgm-review-count');
    if (count && count.textContent) {
      const fixed = formatWithCommas(count.textContent);
      if (fixed !== count.textContent) count.textContent = fixed;
    }
  }

  fixReviewNumbers();
  new MutationObserver(debounce(fixReviewNumbers, 100)).observe(document.body, { childList: true, subtree: true });
})();


// ─── 3. SHADOW DOM───────────────
waitForShadow(function (sr) {

  // ── 3a. Your Cart text
  function fixCartText() {
    const t = sr.querySelector(".side-cart-header p");
    if (t && t.innerText !== "Your Cart") t.innerText = "Your Cart";
  }

  // ── 3b. Progress bar icons
  function keepIcons() {
    sr.querySelectorAll(".icon-wrap").forEach(function (icon, idx) {
      icon.style.border = "none";
      const svg = icon.querySelector("svg");
      if (svg) svg.style.display = "none";
      if (icon.querySelector(".custom-milestone-img")) return;

      const img = document.createElement("img");
      img.className = "custom-milestone-img";
      img.style.cssText = "width:24px;height:24px;object-fit:contain;";
      img.src = idx === 0
        ? "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/Vector.png?v=1776509059"
        : "https://cdn.shopify.com/s/files/1/0034/7901/1441/files/vecteezy_ai-generated-red-gift-box-with-golden-bow-on-transparent_37796385_1.png?v=1776509170";
      icon.appendChild(img);
    });
    sr.querySelectorAll(".steps-wrap").forEach(w => w.style.border = "none");
  }

  // ── 3c. Banner (ek hi function — dono sections ke liye)
  // function replaceBanner() {
  //   const promotionBanner = sr.querySelector(".promotion-banner");
  //   if (!promotionBanner || promotionBanner.querySelector(".custom-brand-banner")) return;
  //   const newBanner = document.createElement("div");
  //   newBanner.className = "custom-brand-banner";
  //   newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";
  //   newBanner.innerHTML = `
  //     <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333"
  //       style="height:14px;vertical-align:middle;margin-right:6px;" />
  //     <span> Brand of the year | Trusted by <strong>20L+</strong> Customers Worldwide</span>`;
  //   promotionBanner.parentNode.replaceChild(newBanner, promotionBanner);
  // }

  function replaceBanner() {
  const promotionBanner = sr.querySelector(".promotion-banner");

  // ✅ Stop if original banner not found
  if (!promotionBanner) return;

  // ✅ Stop if custom banner already exists (anywhere in the same parent)
  if (sr.querySelector(".custom-brand-banner")) return;

  const newBanner = document.createElement("div");
  newBanner.className = "custom-brand-banner";
  newBanner.style.cssText = "background-color:#9B5E34;text-align:center;color:#ffffff;padding:8px 16px;font-size:13px;font-weight:500;";

  newBanner.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/sale_1_1.png?v=1776495333"
      style="height:14px;vertical-align:middle;margin-right:6px;" />
    <span>Brand of the year | Trusted by <strong>20L+</strong> Customers Worldwide</span>
  `;

  // ✅ Replace only once
  promotionBanner.replaceWith(newBanner);
}

  // ── 3d. Checkout messages
  function showMessages() {
    const offerBox = sr.querySelector(".offer-box");
    if (!offerBox) return;

    sr.querySelector(".my-checkout-text")?.remove();
    sr.querySelector(".my-offer-text")?.remove();

    const checkoutMessage = document.createElement("div");
    checkoutMessage.className = "my-checkout-text";
    checkoutMessage.innerHTML = `
      <span>Checkout to unlock additional discounts</span>
      <img src="https://cdn.shopify.com/s/files/1/0034/7901/1441/files/discount_1_2.png?v=1776497527"
        style="height:18px;vertical-align:middle;margin-left:6px;" />`;

    const offerRewardsText = document.createElement("div");
    offerRewardsText.className = "my-offer-text";
    offerRewardsText.innerHTML = `<span>Offer & Rewards</span>`;

    offerBox.parentNode.insertBefore(checkoutMessage, offerBox);
    offerBox.parentNode.insertBefore(offerRewardsText, offerBox);

    checkoutMessage.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const btn = sr.querySelector(".gokwik-checkout, .checkout-button, [data-checkout]");
      if (btn) btn.click();
    });
  }

  // ── 3e. Estimated total → View Details
  function fixEstimatedText() {
    const t = sr.querySelector(".estimated-total");
    if (t && t.innerText !== "View Details") t.innerText = "View Details";
  }

  // ── 3f. Gift text
  function fixGiftText() {
    const el = sr.querySelector(".next-milestone-text");
    if (el && el.innerText === "You have successfully unlocked your rewards!") {
      el.innerText = "You have successfully unlocked your rewards!";
    }
  }

  // ── 3g. Recent product title
  function fixProductTitle() {
    const el = sr.querySelector(".title p, .title");
    if (el && el.innerText === "Try on Sale !") {
      el.innerText = "Products Loved Together !";
    }
  }

  // ── 3h. Price Details popup (guard: sirf ek baar rebuild)
  // function buildPriceDetails() {
  //   const breakdown = sr.querySelector(".order-breakdown");
  //   if (!breakdown || breakdown.querySelector(".custom-price-text")) return;

  //   const itemCount = Array.from(sr.querySelectorAll(".item-quantity"))
  //     .reduce((sum, el) => sum + (parseInt(el.value) || 0), 0);

  //   const get = (sel) => breakdown.querySelector(sel)?.innerText || '₹0';

  //   breakdown.innerHTML = `
  //     <div class="custom-price-text">
  //       <h3 style="margin:0 0 8px;font-size:16px;font-weight:600;">Price Details</h3>
  //       <p style="margin:0 0 12px;font-size:12px;color:#666;">Prices are inclusive of all taxes</p>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
  //         <span>Bag Total (${itemCount} ${itemCount === 1 ? 'item' : 'items'})</span>
  //         <span>${get('.breakdown-row:first-child span:last-child')}</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;color:#2e7d32;">
  //         <span>Discount on MRP</span>
  //         <span>${get('.breakdown-row.discount span:last-child')}</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;font-weight:500;">
  //         <span>Sub Total</span>
  //         <span>${get('.breakdown-row:nth-child(3) span:last-child')}</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;color:#2e7d32;">
  //         <span>Total Discount</span>
  //         <span>${get('.breakdown-row.discount:nth-child(4) span:last-child')}</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
  //         <span>Convenience Charge</span><span>₹70.00</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-bottom:10px;font-size:14px;">
  //         <span>Shipping Charges</span>
  //         <span style="color:#2e7d32;">${get('.breakdown-row:nth-child(7) span:last-child')}</span>
  //       </div>
  //       <div style="display:flex;justify-content:space-between;margin-top:12px;padding-top:12px;border-top:1px solid #eee;font-size:16px;font-weight:700;">
  //         <span>You Pay</span>
  //         <span>${get('.total-row span:last-child')}</span>
  //       </div>
  //     </div>`;
  // }

  function buildPriceDetails() {
    const breakdown = sr.querySelector(".order-breakdown");
    if (!breakdown) {
        // console.log("order-breakdown not found");
        return;
    }
    // console.log("Price breakdown found");
    if (!breakdown.querySelector(".custom-price-header")) {
        const header = document.createElement("div");
        header.className = "custom-price-header";
        header.innerHTML = `
            <h3 class="cstm-price-det">Price Details</h3>
            <p class="cstm-price-enclusive">Prices are inclusive of all taxes</p>
        `;
        breakdown.insertAdjacentElement('afterbegin', header);
        // console.log("Header added");
    }
    const itemCount = Array.from(sr.querySelectorAll(".item-quantity"))
        .reduce((sum, el) => sum + (parseInt(el.value) || 0), 0) || 
        sr.querySelectorAll(".cart-item, .item.svelte-1s3ixll, [class*='item']").length || 1;
    // console.log(`Detected Item Count: ${itemCount}`);
    const walker = document.createTreeWalker(
        breakdown,
        NodeFilter.SHOW_TEXT,
        null,
        false
    );

    let node;
    while (node = walker.nextNode()) {
        let text = node.textContent.trim();
        if (text === "MRP Total" || text === "Bag Total" || text.includes("MRP")) {
            if (!text.includes("Discount")) {
                node.textContent = `Bag Total (${itemCount} ${itemCount === 1 ? 'item' : 'items'})`;
                // console.log(`✅ Bag Total Updated → (${itemCount} items)`);
                continue;
            }
        }
        if (text === "Cart Subtotal") {
            node.textContent = "Sub Total";
        }
        else if (text === "Estimated Total") {
            node.textContent = "You Pay";
        }
    }
}

  // ── 3i. Add note wrapper
  function wrapNotes() {
    const notes = sr.querySelector(".order-note");
    const viewBtn = sr.querySelector(".view-offers-button");
    if (!notes || !viewBtn || notes.closest(".view-notes-wrapper")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "view-notes-wrapper";
    viewBtn.parentNode.insertBefore(wrapper, viewBtn);
    wrapper.appendChild(viewBtn);
    wrapper.appendChild(notes);
  }

  // ── 3j. Upsell card price+button wrapper
  function wrapPriceAndButton() {
    sr.querySelectorAll(".card").forEach(function (card) {
      if (card.querySelector(".price-btn-wrapper")) return;
      const price = card.querySelector(".price");
      const addBtn = card.querySelector(".add-btn");
      if (!price || !addBtn) return;

      const wrapper = document.createElement("div");
      wrapper.className = "price-btn-wrapper";
      wrapper.style.cssText = "display:flex;align-items:center;justify-content:space-between;margin-top:8px;gap:10px;";
      price.parentNode.insertBefore(wrapper, price);
      wrapper.appendChild(price);
      wrapper.appendChild(addBtn);
      price.style.margin = "0";
      addBtn.style.margin = "0";
    });
  }

  // ── 3k. Cart layout styles inject
  function injectCartStyles() {
    if (sr.querySelector("#custom-cart-styles")) return;

    const style = document.createElement("style");
    style.id = "custom-cart-styles";
    style.textContent = `
      .item.svelte-1s3ixll{display:grid!important;grid-template-columns:80px 1fr!important;gap:0 10px!important;align-items:start!important;padding:12px 0!important}
      .product-main-content.svelte-1s3ixll{display:contents!important}
      .img.svelte-1s3ixll{grid-column:1!important;grid-row:1/5!important;width:80px!important;height:80px!important}
      .img.svelte-1s3ixll img{width:80px!important;height:80px!important;object-fit:cover!important;border-radius:8px!important;display:block!important}
      .details.space-between.svelte-1s3ixll{grid-column:2!important;grid-row:1!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:0!important;width:100%!important;padding:0!important}
      .item-price.svelte-1s3ixll{grid-column:2!important;grid-row:2!important;display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;gap:6px!important;margin-top:0!important;width:100%!important}
      .quantity-handler-wrapper.svelte-1s3ixll{grid-column:2!important;grid-row:3!important;display:flex!important;flex-direction:row!important;justify-content:flex-start!important;align-items:center!important;margin-top:6px!important;width:auto!important;}
      .sidecart-product-title.svelte-1s3ixll{font-weight:600!important;font-size:13px!important;line-height:1.3!important;white-space:normal!important}
      .compare-at-price.svelte-1s3ixll{font-size:12px!important;color:#999!important}
      .final-price.svelte-1s3ixll{font-size:14px!important;font-weight:700!important}
      .discount-percentage.svelte-1s3ixll{font-size:11px!important;color:green!important}
      strike.compare-at-price.svelte-1s3ixll{order:2}
    `;
    sr.appendChild(style);
  }

  // ── 3l. Cart layout DOM fix
  function layoutFix() {
    sr.querySelectorAll(".item.svelte-1s3ixll").forEach(function (item) {
      const itemPrice = item.querySelector(".item-price");
      const variantList = item.querySelector(".variant-list");
      const qtyWrapper = item.querySelector(".quantity-handler-wrapper");
      if (itemPrice && variantList && !itemPrice.contains(variantList)) itemPrice.appendChild(variantList);
      if (qtyWrapper && itemPrice && itemPrice.contains(qtyWrapper)) itemPrice.after(qtyWrapper);
    });
  }




  // ── RUN ALL on init
  function runAll() {
    fixCartText();
    keepIcons();
    replaceBanner();
    showMessages();
    fixEstimatedText();
    fixGiftText();
    fixProductTitle();
    buildPriceDetails();
    wrapNotes();
    wrapPriceAndButton();
    injectCartStyles();
    layoutFix();
  }

  runAll();

  // ── SINGLE shadowRoot observer (debounced) — sab kuch yahan handle
  new MutationObserver(debounce(runAll, 120)).observe(sr, {
    childList: true,
    subtree: true,
    characterData: true
  });

});


// ─── 4. JUDGEME REVIEW BADGES IN CART ────────────────────────
(function () {
  const STORAGE_KEY = "jdgm_badge_map_v5";

  function loadStoredMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function saveMap(map) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) {}
  }

  let cachedBadgeMap = loadStoredMap();

  function getStarsFromBadge(prevBadge) {
    return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
      if (star.classList.contains("jdgm--on")) return '<span style="color:#f5a623;font-size:15px;">★</span>';
      if (star.classList.contains("jdgm--half")) return '<span style="color:#f5a623;font-size:15px;">★</span>';
      return '<span style="color:#ddd;font-size:15px;">★</span>';
    }).join("");
  }

  function findTitleNearBadge(badge) {
    let el = badge.parentElement, depth = 0;
    while (el && depth < 8) {
      const t = el.querySelector("h1,h2,h3,h4,.product-title,.card__heading,[class*='title']:not([class*='badge']):not([class*='review'])");
      if (t?.textContent?.trim()) return t.textContent.trim();
      const d = el.getAttribute("data-product-title") || el.getAttribute("data-title") || el.getAttribute("data-name");
      if (d) return d;
      el = el.parentElement; depth++;
    }
    return null;
  }

  function normalize(str) { return str.toLowerCase().replace(/\s+/g, " ").trim(); }

  function buildTitleBadgeMap() {
    const map = loadStoredMap();
    document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
      const prevBadge = badge.querySelector(".jdgm-prev-badge");
      if (!prevBadge) return;
      const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
      const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;
      const jdgmTitle = prevBadge.getAttribute("data-product-title") || badge.getAttribute("data-product-title");
      const title = jdgmTitle || findTitleNearBadge(badge);
      if (!title) return;
      const key = normalize(title);
      if (count === 0 || rating === 0) { delete map[key]; return; }
      const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
      if (!badgeText || badgeText.toLowerCase().includes("no review")) { delete map[key]; return; }
      map[key] = { stars: getStarsFromBadge(prevBadge), text: badgeText, rating, count };
    });
    cachedBadgeMap = map;
    saveMap(map);
    return map;
  }

  // function injectBadges() {
  //   const sc = document.querySelector("shadow-dom-container");
  //   if (!sc?.shadowRoot) return;
  //   const sr = sc.shadowRoot;
  //   const productTitles = sr.querySelectorAll(".sidecart-product-title");
  //   if (!productTitles.length) return;
  //   const badgeMap = Object.keys(cachedBadgeMap).length > 0 ? cachedBadgeMap : buildTitleBadgeMap();
  //   if (!Object.keys(badgeMap).length) return;

  //   productTitles.forEach(function (titleEl) {
  //     if (titleEl.parentElement?.querySelector(".custom-jdgm-review")) return;
  //     const data = badgeMap[normalize(titleEl.textContent || "")];
  //     if (!data) return;

  //     const wrapper = document.createElement("div");
  //     wrapper.className = "custom-jdgm-review";
  //     wrapper.innerHTML = `
  //       <div style="display:flex!important;align-items:center;gap:5px;margin-top:5px;height:auto!important;overflow:visible!important;visibility:visible!important;">
  //         <span style="display:inline-flex!important;gap:1px;">${data.stars}</span>
  //         <span class="review-icon">
  //           <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  //             <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
  //           </svg>
  //         </span>
  //         <span style="font-size:11px;color:#555;white-space:nowrap;">${data.text}</span>
  //       </div>`;
  //     titleEl.insertAdjacentElement("afterend", wrapper);
  //   });
  // }


  function injectBadges() {
    const sc = document.querySelector("shadow-dom-container");
    if (!sc?.shadowRoot) return;
    const sr = sc.shadowRoot;

    const productTitles = sr.querySelectorAll(".sidecart-product-title");
    if (!productTitles.length) return;

    const badgeMap = Object.keys(cachedBadgeMap).length > 0 ? cachedBadgeMap : buildTitleBadgeMap();
    if (!Object.keys(badgeMap).length) return;

    productTitles.forEach(function (titleEl) {
        const item = titleEl.closest('.item');
        if (!item) return;

        const parent = titleEl.parentElement;
        if (!parent || parent.querySelector(".custom-jdgm-review")) return;

        const data = badgeMap[normalize(titleEl.textContent || "")];
        if (!data) return;

        // ================== CLEAN PRICE DETECTION ==================
        let finalPrice = '';
        let comparePrice = '';
        let discountText = '';

        const elements = item.querySelectorAll('*');
        
        elements.forEach(el => {
            let text = el.textContent.trim();
            if (!text) return;

            // Final Price
            if (/₹\s*[\d,]+\.?\d*/.test(text) && 
                !el.closest('strike') && 
                !text.includes('+') && 
                !text.includes('-') &&
                !finalPrice) {
                
                finalPrice = text.match(/₹\s*[\d,]+\.?\d*/)[0];
            }

            if ((el.closest('strike') || 
                 el.style?.textDecoration?.includes('line-through') || 
                 el.tagName === 'STRIKE') && 
                /₹\s*[\d,]+/.test(text) && 
                !comparePrice) {
                
                comparePrice = text.match(/₹\s*[\d,]+\.?\d*/)[0];
            }

            if ((text.includes('%') || text.includes('OFF')) && !discountText) {
                const discountMatch = text.match(/\(?\s*\d+%\s*OFF\s*\)?|(\d+%\s*OFF)/i);
                if (discountMatch) {
                    discountText = discountMatch[0].trim();
                }
            }
        });

        // ================== BUILD HTML ==================
        let priceHTML = '';

        if (finalPrice) {
          const cleanPrice = finalPrice.replace('.00', '');
            priceHTML += `<span class="variant-price">${cleanPrice}</span>`;
        }
        if (comparePrice) {
          const cleanCompareprice = comparePrice.replace('.00', '');
            priceHTML += `<span class="compare-price">${cleanCompareprice}</span>`;
        }
        if (discountText) {
          const cleanDiscountprice = discountText
            .replace(/[()]/g, '')
            .replace(/\s*OFF/g, 'Off');

          priceHTML += `<span class="discount-badge">${cleanDiscountprice}</span>`;
        }

        const reviewWrapper = document.createElement("div");
        reviewWrapper.className = "custom-jdgm-review";
        reviewWrapper.innerHTML = `
            <div class="custom-jdgm-review-flex">
                <span class="cstm-item-stars" style="display:inline-flex!important;gap:4px;">${data.stars}</span>
                <span class="review-icon">
             <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
             </svg>
           </span>
                <span class="cstm-pdp-reviw-txt">${data.text}</span>
            </div>`;

        let qtyWrapper = item.querySelector(".quantity-handler");  
        const title_only = item.querySelector(".sidecart-product-title"); 
        const priceInfo = document.createElement("div");
        priceInfo.className = "custom-price-info";

        const priceRow = document.createElement("div");
        priceRow.style.cssText = "display:flex;align-items:baseline;flex-wrap:wrap;gap:4px;";
        priceRow.innerHTML = priceHTML;

        priceInfo.appendChild(priceRow);

        // Variant List
        const variantList = item.querySelector('.variant-list');
        if (variantList) {
            priceInfo.appendChild(variantList);
        }

        // Insert
        titleEl.insertAdjacentElement("afterend", reviewWrapper);
        reviewWrapper.insertAdjacentElement("afterend", priceInfo);
       // priceInfo.insertAdjacentElement("afterend", qtyWrapper);
        // if(!priceInfo){
        // title_only.insertAdjacentElement("afterend", qtyWrapper);
        // }
    });
}

  window.addEventListener("load", function () {

    if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
    new MutationObserver(debounce(function () {
      if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
    }, 200)).observe(document.body, { childList: true, subtree: true });

   
    waitForShadow(function (sr) {
      if (sr._jdgmObserver) return;
      injectBadges();
      const obs = new MutationObserver(debounce(function () {
        const titles = sr.querySelectorAll(".sidecart-product-title");
        const badges = sr.querySelectorAll(".custom-jdgm-review");
        if (titles.length > 0 && badges.length < titles.length) injectBadges();
      }, 150));
      obs.observe(sr, { childList: true, subtree: true });
      sr._jdgmObserver = obs;
    });

    // Cart button click
    document.addEventListener("click", function (e) {
      if (e.target.closest("[class*='cart'],[id*='cart'],[href*='cart']")) injectBadges();
    }, true);
  });
})();














